import { VideoMeetingSubtitles } from "./VideoMeetingSubtitles";
import { useTranscription } from "@platform/features/video/providers/TranscriptionProvider";
import { useVideoRoster } from "@platform/store";

export function VideoMeetingSubtitlesContainer() {
  const { state } = useTranscription();
  const roster = useVideoRoster();
  const attendeeCount = Object.keys(roster).length;

  return (
    <VideoMeetingSubtitles
      segments={state.segments}
      currentSegment={state.currentSegment}
      isEnabled={state.isTranscribing}
      isLoading={state.isLoading}
      error={state.error}
      attendeeCount={attendeeCount}
    />
  );
}
